import React, { useState } from 'react';

import { Icon } from 'components/ui';
import { ChipWithIcons } from '../../../components';
import { metricTypes } from 'lib/enums/metrics';
import { TemperatureItem } from './TemperatureItem';
import MetricChip from '../../chips/MetricChip';

import useDialog from 'lib/hooks/useDialog';
import CardItemDialog from 'pages/PatientRecordPage/components/MeasuresDialog/CardItemDialog';
import { getMainComponent } from 'lib/utils/metricComponents';
import { useMetricTranslation } from 'lib/hooks/useMetricTranslation';

export const MainMetricItem = React.memo(({ metric, id, isActive }) => {
  const metricDialog = useDialog();
  const { getTranslatedTitle } = useMetricTranslation();
  const multicomponent = metric?.components.length > 1;
  const mainComponent = getMainComponent(metric?.components);

  return (
    <>
      {metric && (
        <MetricChip
          state={metric}
          margin="0 12px 12px 0"
          onClick={
            !multicomponent && isActive ? () => metricDialog.open(id) : null
          }
        />
      )}

      <CardItemDialog
        initialData={{
          title: getTranslatedTitle(
            metric?.metricDefinition,
            metric?.metricDefinition?.title || mainComponent?.code?.coding?.[0]?.display
          ),
          scoreType: metric?.scoreType || mainComponent?.scoreType || 'RISK',
          components: metric?.components,
        }}
        patient={{ id }}
        metricDefinitionId={metric?.metricDefinitionId}
        open={metricDialog.isOpen}
        handleClose={metricDialog.close}
      />
    </>
  );
});
